import React, { ReactNode } from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

// Omit children & title from TooltipProps to redefine them
interface CustomTooltipProps extends Omit<TooltipProps, "children" | "title"> {
  children: ReactNode; // can be string or element
  text: string; // replaces title
}

// Ellipsis wrapper
const EllipsisSpan = styled("span")({
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%", // make it responsive inside container
});

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{
      tooltip: `${className} add-label-item`,
      arrow: "MuiTooltip-arrow",
    }}
  />
))({
  fontSize: "12px",
  fontWeight: 400,
  color: "white",
  backgroundColor: "rgba(50, 51, 56, 1)",
  borderRadius: "4px",
  padding: "8px 10px",
  "& .MuiTooltip-arrow": {
    color: "rgba(50, 51, 56, 1)",
  },
  // Optional: truncate the tooltip text itself
  ".MuiTooltip-tooltip": {
    maxWidth: 300, // limit width of tooltip text
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  text,
  children,
  ...props
}) => {
  return (
    <StyledTooltip title={text || ""} arrow {...props}>
      <span style={{ display: "flex" }}>{children}</span>
    </StyledTooltip>
  );
};

export default CustomTooltip;
